import ready from 'utils/ready';
import {$, $$} from 'utils/selector';

ready().then(() => {

  const className = '.slider';
  const elements = $$(className);

  if (elements.length > 0) {

    Promise.all([
      import (/* webpackChunkName: "slider" */'swiper/core'),
      import (/* webpackChunkName: "slider" */'./slider.css'),
      import (/* webpackChunkName: "slider" */'swiper/swiper-bundle.css')
    ]).then(modules => {

      var Swiper = modules[0].default;
      var Navigation = modules[0].Navigation;
      var Pagination = modules[0].Pagination;

      Swiper.use([Navigation, Pagination]);

      elements.forEach(element => {

        let config = {
          autoHeight: true,

          pagination: {
            el: '.swiper-pagination',
            dynamicBullets: true,
            clickable: true,
            dynamicMainBullets: 1,
          },

          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        };
        let data = element.dataset;
        for (let i in data) {
          let value = data[i];
          if (i == 'slidesperview') {
            config['slidesPerView'] = parseInt(value);
          }
          else if (i == 'loop') {
            config['loop'] = value == 'true';
          }
          else if (i == 'transition') {
            config['effect'] = value;
          }
          else if (i == 'transitionduration') {
            config['speed'] = parseInt(value);
          }
          else if (i == 'autoplayduration') {
            if (value != '') {
              config['autoplay'] = { delay: value };
            }
          }
          else {
            config[i] = value;
          }
        }

        var mySwiper = new Swiper (element, config)
      });

    });

  }

});
